import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-videocall',
  templateUrl: './videocall.component.html',
  styleUrl: './videocall.component.scss',
})
export class VideocallComponent implements AfterViewInit {
  displayTemplate: TemplateRef<any>;

  @ViewChild('localvideo') private localvideo: TemplateRef<any>;
  @ViewChild('remotevideo') private remotevideo: TemplateRef<any>;

  constructor(public apiservice: ApiService, private cd: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.displayTemplate = this.localvideo;
    this.apiservice.remoteVideoStream.subscribe((value: MediaStream) => {
      if (value) {
        this.displayTemplate = this.remotevideo;
      }
    });
    this.apiservice.switchVideos.subscribe((value: boolean) => {
      if (value) {
        if (this.displayTemplate === this.localvideo) {
          this.displayTemplate = this.remotevideo;
        } else {
          this.displayTemplate === this.localvideo;
        }
      }
    });
    this.cd.detectChanges();
  }
}
